import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {AsyncPipe, DatePipe} from "@angular/common";
import {ConfirmationService, MessageService, PrimeTemplate} from "primeng/api";
import {TableModule} from "primeng/table";
import {ApplicationService} from "../../services/application.service";
import {TypedTableRowDirective} from "../../typed-table-row.directive";
import {RouterLink} from "@angular/router";
import {DialogService, DynamicDialogComponent} from "primeng/dynamicdialog";

@Component({
  selector: 'app-applications-tab',
  imports: [
    DatePipe,
    PrimeTemplate,
    TableModule,
    AsyncPipe,
    TypedTableRowDirective,
    RouterLink
  ],
  templateUrl: './delayed-applications-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DelayedApplicationsTabComponent {
  private readonly applicationService = inject(ApplicationService);
  protected readonly applications$ = this.applicationService.getDelayedApplications();
}
